import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { EnderecoDTO } from "../../components/recadastramento-aba4/endereco.dto";
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";
import {MunicipioDto} from "../../components/recadastramento-aba4/municipio.dto";
import {Page} from "../../model/Paginacao/Page";

@Injectable()
export class EnderecoAba4Service extends GenericService {

    private basePath = 'api/v1';
    private path = '/endereco';
    url = environment.url;

    constructor(http: HttpClient) {
        super(http);
    }

    getEnderecoPessoal(): Observable<EnderecoDTO> {
        return this.http.get<EnderecoDTO>(this.url + this.basePath + this.path);
    }

    getArquivo(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + '/visualizar_comprovante' + this.path , options);
    }

    atualizarEndereco(data): Observable<any> {
        return this.http.patch(this.url + this.basePath + this.path, data);
    }

    salvarEnderecoPessoal(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.patchMethodFile(this.url + this.basePath + '/upload_comprovante' + this.path, formData);
    }

    uploadComprovanteCnh(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.postMethodFile(this.basePath + this.path + '/upload-documentos-pessoais/cnh', formData);
    }

    uploadComprovanteTitulo(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.postMethodFile(this.basePath + this.path + '/upload-documentos-pessoais/titulo-eleitor', formData);
    }
    deletarComprovanteEndereco(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.url + this.basePath + '/comprovante-deletar/endereco', options);
    }

    getVerificarMunicioValido(municipio: string, estado: string): Observable<MunicipioDto> {
        return this.http.get<MunicipioDto>(this.url + this.basePath + `/municipio/${municipio}/estado/${estado}/verifica-valido`);
    }

    getOpcoesAutoComplete(municipio: string): Observable<Page<any>> {
        return this.http.get<Page<any>>(this.url + this.basePath + `/municipio/${municipio}/pagina/0/tamanho/20`);
    }
}
